(function() {
  let isUpdating = false;
  let initScheduled = false;
  let forceInitScheduled = false;
  let incompleteMenuRetries = 0;

  const MAX_INCOMPLETE_MENU_RETRIES = 15;
  const drawerOriginalMarkup = new WeakMap();

  function getMegaMenuConfig() {
    const configEl = document.getElementById('mega-menus-config');

    if (configEl) {
      return {
        showChevron: configEl.dataset.showChevron === 'true',
        triggerMethod: configEl.dataset.triggerMethod || 'click'
      };
    }

    return {
      showChevron: true,
      triggerMethod: 'click'
    };
  }

  function scheduleInit(forceUpdate = false) {
    if (forceUpdate) {
      forceInitScheduled = true;
    }

    if (initScheduled) {
      return;
    }

    initScheduled = true;

    requestAnimationFrame(() => {
      initScheduled = false;
      const shouldForceUpdate = forceInitScheduled;
      forceInitScheduled = false;
      initMegaMenu(shouldForceUpdate);
    });
  }

  function getDesktopMenuItems(headerMenu) {
    const overflowList = headerMenu.querySelector('overflow-list');

    if (overflowList) {
      return Array.from(overflowList.children).filter((item) => item.matches('li.menu-list__list-item'));
    }

    const navList = headerMenu.querySelector('.menu-list__nav-list');

    if (!navList) {
      return [];
    }

    return Array.from(navList.children).filter((item) => item.matches('li.menu-list__list-item'));
  }

  function cleanupDesktop(headerMenu) {
    const removeGeneratedElements = (elements) => {
      elements.forEach((element) => {
        const listItem = element.closest('li');

        if (listItem) {
          const link = listItem.querySelector('.menu-list__link');

          if (link) {
            if (link.hasAttribute('data-original-href')) {
              link.setAttribute('href', link.getAttribute('data-original-href'));
              link.removeAttribute('data-original-href');
            }

            link.removeAttribute('aria-haspopup');
            link.removeAttribute('aria-expanded');
            link.removeAttribute('aria-controls');
            link.removeAttribute('data-click-listener');

            const arrow = link.querySelector('.custom-mega-menu-arrow');
            if (arrow) {
              arrow.remove();
            }
          }

          listItem.removeAttribute('data-hover-listener');
          listItem.removeAttribute('data-hover-blocked');
          listItem.classList.remove(
            'has-submenu',
            'mega-menu-trigger-hover',
            'mega-menu-trigger-click',
            'is-open',
            'menu-list__list-item--mega'
          );
        }

        element.classList.remove('menu-list__submenu--mega');
        element.remove();
      });
    };

    document.querySelectorAll('.custom-mega-menu-arrow').forEach((element) => element.remove());

    removeGeneratedElements(headerMenu.querySelectorAll('[data-generated-submenu="true"]'));

    const injectedElements = headerMenu.querySelectorAll('[data-mega-menu-injected="true"]');
    injectedElements.forEach((element) => {
      if (!element.closest('[data-generated-submenu="true"]')) {
        element.innerHTML = '';
        element.removeAttribute('data-mega-menu-injected');

        const submenu = element.closest('.menu-list__submenu');
        if (submenu && submenu.hasAttribute('data-removed-dropdown')) {
          submenu.classList.add('menu-list__submenu--dropdown');
          submenu.removeAttribute('data-removed-dropdown');
        }

        const listItem = element.closest('li');
        if (listItem && listItem.hasAttribute('data-removed-li-dropdown')) {
          listItem.classList.add('menu-list__list-item--dropdown');
          listItem.removeAttribute('data-removed-li-dropdown');
        }

        const link = listItem?.querySelector('.menu-list__link');
        if (link && link.hasAttribute('data-original-href')) {
          link.setAttribute('href', link.getAttribute('data-original-href'));
          link.removeAttribute('data-original-href');
        }
      }
    });

    headerMenu.querySelectorAll('.menu-list__chevron').forEach((arrow) => {
      arrow.style.display = '';
    });
  }

  function updateArrowPosition(listItem) {
    const submenu = listItem.querySelector('.menu-list__submenu');

    if (!submenu) {
      return;
    }

    const itemRect = listItem.getBoundingClientRect();
    const center = itemRect.left + (itemRect.width / 2);

    submenu.style.setProperty('--arrow-left', `${center}px`);
  }

  function updateDesktopOpenState(listItem, isOpen) {
    const headerMenu = document.querySelector('header-menu');
    const submenu = listItem.querySelector('.menu-list__submenu');

    if (!headerMenu) {
      return;
    }

    if (isOpen && submenu && !submenu.classList.contains('menu-list__submenu--dropdown')) {
      const height = submenu.offsetHeight;
      headerMenu.style.setProperty('--submenu-height', `${height}px`);
      headerMenu.style.setProperty('--submenu-opacity', '1');
      headerMenu.dataset.overflowExpanded = 'true';
      return;
    }

    headerMenu.style.setProperty('--submenu-height', '0px');
    headerMenu.style.setProperty('--submenu-opacity', '0');
    headerMenu.dataset.overflowExpanded = 'false';
  }

  function bindDesktopTrigger(listItem, link, triggerMethod) {
    listItem.classList.remove('mega-menu-trigger-hover', 'mega-menu-trigger-click');
    listItem.classList.add(`mega-menu-trigger-${triggerMethod}`);

    if (triggerMethod === 'click') {
      if (!listItem.hasAttribute('data-hover-blocked')) {
        listItem.setAttribute('data-hover-blocked', 'true');

        const blockHover = (event) => {
          if (listItem.classList.contains('mega-menu-trigger-click')) {
            event.stopImmediatePropagation();
          }
        };

        listItem.addEventListener('pointerenter', blockHover, true);
        listItem.addEventListener('mouseenter', blockHover, true);
        listItem.addEventListener('mouseover', blockHover, true);
      }

      if (!link.hasAttribute('data-click-listener')) {
        link.setAttribute('data-click-listener', 'true');
        link.addEventListener('click', (event) => {
          if (!listItem.classList.contains('mega-menu-trigger-click')) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          const isOpen = listItem.classList.contains('is-open');

          document.querySelectorAll('.mega-menu-trigger-click.is-open').forEach((openListItem) => {
            if (openListItem !== listItem) {
              openListItem.classList.remove('is-open');
            }
          });

          listItem.classList.toggle('is-open', !isOpen);
          updateArrowPosition(listItem);
          updateDesktopOpenState(listItem, !isOpen);
        });
      }

      return;
    }

    if (!listItem.hasAttribute('data-hover-listener')) {
      listItem.setAttribute('data-hover-listener', 'true');
      listItem.addEventListener('mouseenter', () => {
        if (listItem.classList.contains('mega-menu-trigger-hover')) {
          updateArrowPosition(listItem);
        }
      });

      if (!link.hasAttribute('data-click-listener')) {
        link.setAttribute('data-click-listener', 'true');
        link.addEventListener('click', (event) => {
          if (listItem.classList.contains('mega-menu-trigger-hover')) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      }
    }
  }

  function ensureDesktopSubmenu(listItem, displayType, dropdownRadius) {
    let submenu = listItem.querySelector('.menu-list__submenu');
    let submenuInner;

    if (!submenu) {
      submenu = document.createElement('div');
      submenu.className = 'menu-list__submenu color-scheme-matches-parent';
      submenu.setAttribute('ref', 'submenu[]');
      submenu.setAttribute('data-generated-submenu', 'true');

      submenuInner = document.createElement('div');
      submenuInner.className = 'menu-list__submenu-inner';
      submenuInner.id = `submenu-custom-${Math.random().toString(36).slice(2, 11)}`;

      submenu.appendChild(submenuInner);
      listItem.appendChild(submenu);
    } else {
      submenuInner = submenu.querySelector('.menu-list__submenu-inner');
    }

    if (displayType === 'dropdown') {
      submenu.classList.add('menu-list__submenu--dropdown');
      submenu.classList.remove('menu-list__submenu--mega');
      listItem.classList.add('menu-list__list-item--dropdown');
      listItem.classList.remove('menu-list__list-item--mega');
      listItem.style.position = 'relative';
      submenu.style.setProperty('--custom-mega-dropdown-radius', `${dropdownRadius || 0}px`);
      submenu.removeAttribute('data-removed-dropdown');
    } else {
      if (submenu.classList.contains('menu-list__submenu--dropdown')) {
        submenu.classList.remove('menu-list__submenu--dropdown');
        submenu.setAttribute('data-removed-dropdown', 'true');
      }

      submenu.classList.add('menu-list__submenu--mega');
      listItem.classList.remove('menu-list__list-item--dropdown');
      listItem.classList.add('menu-list__list-item--mega');
      listItem.style.position = '';
      submenu.style.removeProperty('--custom-mega-dropdown-radius');
    }

    return submenuInner;
  }

  function injectDesktopMenus(forceUpdate) {
    const headerMenu = document.querySelector('header-menu');

    if (!headerMenu) {
      return;
    }

    const config = getMegaMenuConfig();
    const templates = document.querySelectorAll('[data-mega-menu-template]');
    const menuItems = getDesktopMenuItems(headerMenu);

    // If the nav items aren't all present yet (e.g. a section re-render, hot
    // reload, or third-party script is mid-flight), do NOT tear the menus down.
    // cleanupDesktop() removes every arrow/submenu up front, and if the target
    // items are momentarily missing we'd fail to re-attach them — leaving the
    // chevrons gone and the dropdowns dead. Retry shortly instead.
    const maxMenuIndex = Array.from(templates).reduce((max, template) => {
      const index = Number.parseInt(template.getAttribute('data-menu-index'), 10) || 0;
      return index > max ? index : max;
    }, 0);

    if (maxMenuIndex > 0 && menuItems.length < maxMenuIndex) {
      if (incompleteMenuRetries < MAX_INCOMPLETE_MENU_RETRIES) {
        incompleteMenuRetries += 1;
        setTimeout(() => scheduleInit(true), 200);
      }
      return;
    }

    incompleteMenuRetries = 0;

    if (forceUpdate) {
      cleanupDesktop(headerMenu);
    }

    templates.forEach((template) => {
      const menuIndex = Number.parseInt(template.getAttribute('data-menu-index'), 10);

      if (!menuIndex || menuIndex < 1 || menuIndex > menuItems.length) {
        return;
      }

      const listItem = menuItems[menuIndex - 1];
      const link = listItem.querySelector('.menu-list__link');

      if (!link) {
        return;
      }

      if (link.hasAttribute('href') && !link.hasAttribute('data-original-href')) {
        link.setAttribute('data-original-href', link.getAttribute('href'));
      }

      // Keep the server-rendered href available to crawlers and assistive
      // technology. The click handler below still prevents navigation while
      // the mega menu is acting as an interactive trigger.
      link.style.cursor = 'pointer';

      if (listItem.classList.contains('menu-list__list-item--dropdown')) {
        listItem.classList.remove('menu-list__list-item--dropdown');
        listItem.setAttribute('data-removed-li-dropdown', 'true');
      }

      const existingThemeArrow = link.querySelector('.menu-list__chevron');
      const existingCustomArrow = link.querySelector('.custom-mega-menu-arrow');

      if (config.showChevron) {
        if (existingThemeArrow) {
          existingThemeArrow.style.display = '';
        } else if (!existingCustomArrow) {
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('class', 'menu-list__chevron custom-mega-menu-arrow');
          svg.setAttribute('viewBox', '0 0 10 6');
          svg.setAttribute('fill', 'none');
          svg.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>';
          link.appendChild(svg);
        }
      } else {
        if (existingCustomArrow) {
          existingCustomArrow.remove();
        }

        if (existingThemeArrow) {
          existingThemeArrow.style.display = 'none';
        }
      }

      bindDesktopTrigger(listItem, link, config.triggerMethod);

      const dropdownRadius = Number.parseInt(template.getAttribute('data-dropdown-radius'), 10);
      const submenuInner = ensureDesktopSubmenu(listItem, template.getAttribute('data-display-type'), dropdownRadius);

      if (!submenuInner) {
        return;
      }

      if (!forceUpdate && submenuInner.hasAttribute('data-mega-menu-injected')) {
        return;
      }

      submenuInner.innerHTML = template.innerHTML;
      submenuInner.setAttribute('data-mega-menu-injected', 'true');

      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', submenuInner.id);
      listItem.classList.add('has-submenu');
    });
  }

  function getHeaderDrawers() {
    return Array.from(document.querySelectorAll('header-drawer'));
  }

  function getDrawerMenuItems(headerDrawer) {
    const menu = headerDrawer.querySelector('.menu-drawer__navigation > .menu-drawer__menu');

    if (!menu) {
      return [];
    }

    return Array.from(menu.children).filter((item) => item.matches('li'));
  }

  function getDrawerTrigger(listItem) {
    return listItem.querySelector(':scope > accordion-custom > details > summary.menu-drawer__menu-item--mainlist, :scope > details > summary.menu-drawer__menu-item--mainlist, :scope > a.menu-drawer__menu-item--mainlist');
  }

  function getDrawerTarget(listItem) {
    const accordionDetails = listItem.querySelector(':scope > accordion-custom > details');
    if (accordionDetails) {
      const accordionList = accordionDetails.querySelector(':scope > ul.menu-drawer__menu');
      if (accordionList) {
        return {
          type: 'list',
          element: accordionList
        };
      }
    }

    const detailsContainer = listItem.querySelector(':scope > details.menu-drawer__menu-container, :scope > details');
    if (detailsContainer) {
      const innerSubmenu = detailsContainer.querySelector(':scope > .menu-drawer__submenu > .menu-drawer__inner-submenu');
      if (innerSubmenu) {
        return {
          type: 'panel',
          element: innerSubmenu
        };
      }
    }

    const flatChildList = listItem.querySelector(':scope > ul.menu-drawer__menu');
    if (flatChildList) {
      return {
        type: 'list',
        element: flatChildList
      };
    }

    return null;
  }

  function cleanupDrawer(headerDrawer) {
    headerDrawer.querySelectorAll('[data-mega-menu-drawer-target="true"]').forEach((target) => {
      const originalMarkup = drawerOriginalMarkup.get(target);

      if (typeof originalMarkup === 'string') {
        target.innerHTML = originalMarkup;
      }

      target.removeAttribute('data-mega-menu-drawer-target');
    });

    headerDrawer.querySelectorAll('[data-mega-menu-drawer-injected="true"]').forEach((element) => {
      if (!element.closest('[data-mega-menu-drawer-target="true"]')) {
        element.remove();
      }
    });

    headerDrawer.querySelectorAll('.custom-mega-drawer-host').forEach((listItem) => {
      listItem.classList.remove('custom-mega-drawer-host', 'is-open');
      listItem.removeAttribute('data-custom-mega-menu-index');
    });

    headerDrawer.querySelectorAll('[data-mega-menu-drawer-trigger="true"]').forEach((trigger) => {
      trigger.removeAttribute('data-mega-menu-drawer-trigger');
      trigger.removeAttribute('role');
      trigger.removeAttribute('aria-expanded');

      if (trigger.dataset.originalHref) {
        trigger.setAttribute('href', trigger.dataset.originalHref);
        delete trigger.dataset.originalHref;
      }
    });
  }

  function injectIntoDrawerTarget(target, type, html) {
    if (!drawerOriginalMarkup.has(target)) {
      drawerOriginalMarkup.set(target, target.innerHTML);
    }

    target.setAttribute('data-mega-menu-drawer-target', 'true');

    if (type === 'list') {
      target.innerHTML = '';

      const listItem = document.createElement('li');
      listItem.className = 'menu-drawer__list-item custom-mega-drawer__list-item';
      listItem.setAttribute('data-mega-menu-drawer-injected', 'true');
      listItem.innerHTML = html;

      target.appendChild(listItem);
      return;
    }

    target.querySelectorAll(':scope > :not(.menu-drawer__nav-buttons)').forEach((child) => child.remove());

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-mega-drawer__injected';
    wrapper.setAttribute('data-mega-menu-drawer-injected', 'true');
    wrapper.innerHTML = html;

    target.appendChild(wrapper);
  }

  function bindStandaloneDrawerTrigger(listItem, trigger) {
    if (!trigger || trigger.tagName !== 'A') {
      return;
    }

    if (trigger.hasAttribute('href') && !trigger.dataset.originalHref) {
      trigger.dataset.originalHref = trigger.getAttribute('href');
    }

    trigger.removeAttribute('href');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-expanded', listItem.classList.contains('is-open') ? 'true' : 'false');
    trigger.setAttribute('data-mega-menu-drawer-trigger', 'true');
    trigger.dataset.megaMenuDrawerToggleBound = 'true';
  }

  function injectStandaloneDrawerPanel(listItem, html) {
    let panel = listItem.querySelector(':scope > .custom-mega-drawer__standalone[data-mega-menu-drawer-injected="true"]');

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'custom-mega-drawer__standalone';
      panel.setAttribute('data-mega-menu-drawer-injected', 'true');
      listItem.appendChild(panel);
    }

    panel.innerHTML = html;
    panel.hidden = !listItem.classList.contains('is-open');
  }

  function injectDrawerMenus(forceUpdate) {
    const templates = document.querySelectorAll('[data-mega-menu-drawer-template]');

    if (!templates.length) {
      getHeaderDrawers().forEach(cleanupDrawer);
      return;
    }

    getHeaderDrawers().forEach((headerDrawer) => {
      if (forceUpdate) {
        cleanupDrawer(headerDrawer);
      }

      const menuItems = getDrawerMenuItems(headerDrawer);

      templates.forEach((template) => {
        const menuIndex = Number.parseInt(template.getAttribute('data-menu-index'), 10);

        if (!menuIndex || menuIndex < 1 || menuIndex > menuItems.length) {
          return;
        }

        const listItem = menuItems[menuIndex - 1];
        if (!listItem) {
          return;
        }

        listItem.classList.add('custom-mega-drawer-host');
        listItem.setAttribute('data-custom-mega-menu-index', String(menuIndex));

        const target = getDrawerTarget(listItem);

        if (target) {
          if (!forceUpdate && target.element.querySelector('[data-mega-menu-drawer-injected="true"]')) {
            return;
          }

          injectIntoDrawerTarget(target.element, target.type, template.innerHTML);
          return;
        }

        const trigger = getDrawerTrigger(listItem);
        if (!trigger) {
          return;
        }

        bindStandaloneDrawerTrigger(listItem, trigger);
        injectStandaloneDrawerPanel(listItem, template.innerHTML);
      });
    });
  }

  function initMegaMenu(forceUpdate) {
    if (isUpdating) {
      return;
    }

    isUpdating = true;

    try {
      injectDesktopMenus(forceUpdate);
      injectDrawerMenus(forceUpdate);
    } finally {
      setTimeout(() => {
        isUpdating = false;
      }, 0);
    }
  }

  document.addEventListener('click', (event) => {
    const drawerSummary = event.target.closest('header-drawer summary');

    if (drawerSummary) {
      requestAnimationFrame(() => scheduleInit(true));
      requestAnimationFrame(() => {
        requestAnimationFrame(() => scheduleInit(true));
      });
    }

    const drawerTrigger = event.target.closest('[data-mega-menu-drawer-trigger="true"]');

    if (drawerTrigger) {
      const listItem = drawerTrigger.closest('.custom-mega-drawer-host');
      const panel = listItem?.querySelector(':scope > .custom-mega-drawer__standalone[data-mega-menu-drawer-injected="true"]');

      if (listItem && panel) {
        event.preventDefault();
        event.stopPropagation();

        const shouldOpen = !listItem.classList.contains('is-open');

        document.querySelectorAll('.custom-mega-drawer-host.is-open').forEach((openItem) => {
          if (openItem === listItem) {
            return;
          }

          openItem.classList.remove('is-open');

          const openPanel = openItem.querySelector(':scope > .custom-mega-drawer__standalone[data-mega-menu-drawer-injected="true"]');
          if (openPanel) {
            openPanel.hidden = true;
          }

          const openTrigger = openItem.querySelector(':scope > .menu-drawer__menu-item[role="button"]');
          if (openTrigger) {
            openTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        listItem.classList.toggle('is-open', shouldOpen);
        panel.hidden = !shouldOpen;
        drawerTrigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      return;
    }

    if (event.target.closest('.mega-menu-trigger-click')) {
      return;
    }

    document.querySelectorAll('.mega-menu-trigger-click.is-open').forEach((listItem) => {
      listItem.classList.remove('is-open');
    });

    const headerMenu = document.querySelector('header-menu');
    if (headerMenu) {
      headerMenu.style.setProperty('--submenu-height', '0px');
      headerMenu.style.setProperty('--submenu-opacity', '0');
      headerMenu.dataset.overflowExpanded = 'false';
    }
  });

  function markMegaMenuReady() {
    document.documentElement.setAttribute('data-mega-menu-ready', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleInit(false));
  } else {
    scheduleInit(false);
  }

  // Keep injected mega-menu panels closed until the page has fully loaded and
  // the menus have been injected. Without this gate the base theme can reveal a
  // panel (via aria-expanded) mid-load, causing the dropdown to flash open on
  // first visit before closing once everything settles.
  if (document.readyState === 'complete') {
    requestAnimationFrame(markMegaMenuReady);
  } else {
    window.addEventListener('load', () => requestAnimationFrame(markMegaMenuReady), { once: true });
  }

  // window.addEventListener('load', () => {
  //   scheduleInit(true);
  //   setTimeout(() => scheduleInit(true), 250);
  //   setTimeout(() => scheduleInit(true), 800);
  // });

  // setTimeout(() => scheduleInit(true), 300);
  // setTimeout(() => scheduleInit(true), 1200);

  // One post-load reconciliation.
  window.addEventListener('load', () => {
    scheduleInit(false);
  }, { once: true });

  const INJECTION_SELECTOR = '[data-generated-submenu="true"], [data-mega-menu-injected="true"], .custom-mega-menu-arrow';

  const documentObserver = new MutationObserver((mutations) => {
    // Ignore mutations caused by our own inject/cleanup pass (guarded by
    // isUpdating) so self-healing below can't loop.
    if (isUpdating) {
      return;
    }

    const shouldForceUpdate = mutations.some((mutation) => {
      if (mutation.type === 'attributes' && mutation.target.id === 'mega-menus-config') {
        return true;
      }

      // Self-heal: a section re-render / hot reload / app script removed our
      // injected chevrons or submenus — re-inject so the dropdowns keep working.
      const injectionRemoved = [...mutation.removedNodes].some((node) => {
        if (node.nodeType !== 1) {
          return false;
        }

        return node.matches?.(INJECTION_SELECTOR) || node.querySelector?.(INJECTION_SELECTOR);
      });

      if (injectionRemoved) {
        return true;
      }

      const changedNodes = [...mutation.addedNodes, ...mutation.removedNodes];

      return changedNodes.some((node) => {
        if (node.nodeType !== 1) {
          return false;
        }

        return node.id === 'mega-menus-config'
          || node.matches?.('header-menu, header-drawer')
          || node.hasAttribute?.('data-mega-menu-template')
          || node.hasAttribute?.('data-mega-menu-drawer-template');
      });
    });

    if (shouldForceUpdate) {
      scheduleInit(true);
    }
  });

  documentObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-show-chevron', 'data-trigger-method']
  });

  document.addEventListener('shopify:section:load', () => scheduleInit(true));
  document.addEventListener('shopify:block:select', () => scheduleInit(true));
  document.addEventListener('shopify:block:deselect', () => scheduleInit(true));
})();
